
import { MainBillsComponent } from "./components/main-bills.component";
import { MainBillComponent } from "./components/main-bill.component";
import { MainBillGYHComponent } from "./components/main-bill-gyh.component";
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';
import { AuthService } from '../../injections/auth.service';

export const appRoutes: Routes = [
    {
        path: 'bills',
        component: MainBillsComponent,
        canActivate: [AuthService]
    },
    {
        path: 'bills/cleaner/:id',
        component: MainBillComponent,
        canActivate: [AuthService]
    },
    {
        path: 'bills/gyh/:id',
        component: MainBillGYHComponent,
        canActivate: [AuthService]
    },
];


@NgModule({
    imports: [
        RouterModule.forChild(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class BillsRoutes { }


// WEBPACK FOOTER //
// ./src/app/modules/bills/bills.routes.ts